import { Box, HStack, Link, ListItem, Text, UnorderedList, VStack } from '@chakra-ui/react';

import { trackCompetitorPolicyLinkClicked } from '../../../../../../services/analytics/marketplaceEvents';
import { CompetitorTruth } from './competitorTruth';

type CompetitorPolicyPopoverContentProps = {
  truth: CompetitorTruth;
  dealId: string;
  leadId: string;
};

const CompetitorPolicyPopoverContent = ({
  truth,
  dealId,
  leadId,
}: CompetitorPolicyPopoverContentProps) => (
  <Box textAlign="left">
    <Text
      fontSize="11px"
      fontWeight="800"
      letterSpacing="0.07em"
      textTransform="uppercase"
      color="grayLight"
      mb="8px"
    >
      {truth.heading}
    </Text>
    <VStack spacing="8px" align="stretch">
      {truth.body.map((paragraph) => (
        <Box key={paragraph.text}>
          <Text fontSize="13px" color="charcoal" lineHeight="1.55">
            {paragraph.text}
          </Text>
          {paragraph.bullets != null && (
            <UnorderedList fontSize="13px" color="charcoal" lineHeight="1.55" mt="4px">
              {paragraph.bullets.map((bullet) => (
                <ListItem key={bullet}>{bullet}</ListItem>
              ))}
            </UnorderedList>
          )}
        </Box>
      ))}
    </VStack>
    <HStack spacing="16px" mt="12px">
      {truth.links.map((link) => (
        <Link
          key={link.competitor}
          href={link.href}
          isExternal
          fontSize="13px"
          fontWeight="600"
          color="leaseEndBlue"
          onClick={() =>
            trackCompetitorPolicyLinkClicked(dealId, leadId, truth.bucket, link.competitor)
          }
        >
          {link.label}
        </Link>
      ))}
    </HStack>
  </Box>
);

export default CompetitorPolicyPopoverContent;
